<template>
  <div
    id="app"
    class="relative z-10 flex flex-col w-full min-h-screen bg-zinc-100"
  >
    <MainLoading />
    <MainDialog />
    <ShopCartDialog />
    <router-view class="relative z-20 flex-1" @set-meta="SetMetaData" />
    <MainFooter />
  </div>
</template>

<script>
import MainDialog from "@/components/MainDialog.vue";
import MainLoading from "@/components/MainLoading.vue";
import MainFooter from "./components/MainFooter.vue";
import ShopCartDialog from "@/components/ShopCartDialog.vue";
import { GetMetaData } from "@/common/meta";
import { setLocalStorage, delLocalStorage } from "@/common/cookie";
export default {
  name: "App",
  components: {
    MainDialog,
    MainLoading,
    MainFooter,
    ShopCartDialog,
  },
  data() {
    return {
      meta_data: null,
    };
  },
  methods: {
    SetMetaData(title, content, image) {
      this.meta_data = GetMetaData(title, content, image);
    },
  },
  created() {
    const currentUrl = new URL(window.location.href);
    const urlParams = currentUrl.searchParams;

    if (urlParams.has("order_memo")) {
      setLocalStorage("order_memo", urlParams.get("order_memo"));
    } else {
      delLocalStorage("order_memo");
    }
    this.$store.dispatch("getBasePageData");
  },
  metaInfo() {
    return this.meta_data;
  },
};
</script>

<style src="@/assets/css/output.css"></style>
